import { findPageByPathWithId, getPagePath, getParentId } from '../utils/pagePaths.js'

const MEDIA_PATH = /^(?:\/(.+))?\/([^/]+)\.(?:img|vid)$/

function galleryType(page) {
    return page?.gallery?.type || page?.gallery || null
}

/**
 * A viewer opened from a gallery keeps the gallery page mounted underneath:
 * closing the viewer then only uncovers it, already scrolled into place.
 * - A media URL on a masonry page sits over that page (tile: the image).
 * - An editorial story, or one of its pictures, sits over its directory
 *   parent (tile: the story's link).
 * Backgrounds are exact canonical paths, so they never redirect (editorial
 * slideshows and legacy single-segment slugs do).
 */
export function viewerBackground(pathname, content, { editorFrame = false } = {}) {
    const pages = content?.pages || {}
    const media = pathname.match(MEDIA_PATH)

    const slug = media ? (media[1] || null) : pathname.replace(/^\/+|\/+$/g, '') || null
    const found = slug ? findPageByPathWithId(slug, pages) : null
    const page = slug ? found?.page : content?.home
    if (!page || (slug && getPagePath(page, pages) !== slug)) return null

    if (media && galleryType(page) === 'masonry') {
        return { pathname: slug ? `/${slug}` : '/', tileAttr: 'data-image-id', tileId: media[2], page }
    }

    // An empty slideshow has nothing to cover the parent with. In the editor the
    // parent would also share the open page's edit paths, so it is not drawn.
    const hasImages = Array.isArray(page.gallery?.images) && page.gallery.images.length > 0
    if (slug && found?.id && galleryType(page) === 'slideshow' && hasImages && !editorFrame) {
        const parentId = getParentId(page)
        const parent = parentId ? pages[parentId] : content?.home
        if (!parent || galleryType(parent) !== 'directory') return null
        const parentPath = parentId ? getPagePath(parent, pages) : ''
        if (parentId && !parentPath) return null
        return { pathname: parentPath ? `/${parentPath}` : '/', tileAttr: 'data-page-id', tileId: found.id, page }
    }
    return null
}
